// src/lib/levels.js

/**
 * CUMULATIVE XP thresholds to reach each level.
 * Index 0 => Level 2, index 1 => Level 3, etc.
 *
 * This curve assumes most completed levels award around 100 XP.
 */
export const LEVEL_THRESHOLDS = [100, 200, 300, 450, 600, 800, 1000, 1250];

/** Return the user's LEVEL from total XP. */
export function levelFromXp(totalXp, thresholds = LEVEL_THRESHOLDS) {
  let level = 1; // Level 1 from 0 XP
  for (let i = 0; i < thresholds.length; i++) {
    if (totalXp >= thresholds[i]) level = i + 2;
    else break;
  }
  return level;
}

/**
 * Return detailed progress for the CURRENT level.
 * - level: current level number
 * - floorXp: cumulative XP at the start of this level
 * - nextLevelXp: cumulative XP required for next level (null if max)
 * - xpIntoLevel: XP earned since floorXp
 * - xpToNext: XP remaining to reach next level (0 if max)
 * - percent: 0..100 progress within the current level span
 */
export function levelProgress(totalXp, thresholds = LEVEL_THRESHOLDS) {
  const level = levelFromXp(totalXp, thresholds);
  const prevIdx = level - 2;
  const floorXp = prevIdx >= 0 ? thresholds[prevIdx] : 0;
  const nextIdx = level - 1;
  const nextLevelXp = nextIdx < thresholds.length ? thresholds[nextIdx] : null;

  const xpIntoLevel = totalXp - floorXp;
  const xpToNext = nextLevelXp != null ? Math.max(0, nextLevelXp - totalXp) : 0;

  const span = nextLevelXp != null ? nextLevelXp - floorXp : 1;
  const percent =
    nextLevelXp != null
      ? Math.max(0, Math.min(100, Math.round((xpIntoLevel / span) * 100)))
      : 100;

  return { level, floorXp, nextLevelXp, xpIntoLevel, xpToNext, percent };
}